<proffeo-ui-dialog [title]="'project-locations.modals.duplicate-location-modal-title' | translate">
  <div class="flex flex-row w-full h-full gap-2">
    <div class="flex flex-col w-full h-full gap-2">
      @for (availableLocation of availableLocations(); track availableLocation?.id) {
        <proffeo-select-location-list-item
          (locationSelected)="selectedLocation = $event"
          [location]="availableLocation"
        ></proffeo-select-location-list-item>
      }
    </div>
  </div>

  <div
    dialog-actions
    class="flex flex-col w-full justify-end gap-2"
  >
    <div>
      <mat-checkbox
        (change)="onDuplicateChildrenChange($event)"
        [checked]="duplicateChildren()"
      >
        {{ 'project-locations.modals.duplicate-children' | translate }}
      </mat-checkbox>
    </div>
    <div>
      <mat-checkbox
        (change)="onDuplicateAttachmentsChange($event)"
        [checked]="duplicateAttachments()"
      >
        {{ 'project-locations.modals.duplicate-files' | translate }}
      </mat-checkbox>
    </div>
    <div class="flex w-full justify-end gap-2">
      <proffeo-ui-button
        (clicked)="onClose()"
        [text]="'close' | translate"
        variant="primary"
      ></proffeo-ui-button>
      <proffeo-ui-button
        (clicked)="save()"
        [disabled]="isSaving()"
        [text]="'save-and-close' | translate"
        variant="accent"
      ></proffeo-ui-button>
    </div>
  </div>
</proffeo-ui-dialog>
